import { mount } from "../src"
mount(document.getElementById("root"))
